export default __webpack_public_path__ + "static/media/conversation.6b379c30.svg";